import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { Icon } from '@cld/icon';
import { globalTheme } from '@cld/component-theme';
import { withItemContext } from '../ItemContext';
import { iconTwoLineSizeVariant } from '../theme';
import { SuppportedLayoutTypographySize } from '../types';
import { ActionsWrapper, LayoutBaseProps, layoutTypographyMixin, SelectedIcon } from './common';

export interface IconTwoLineLayoutProps extends LayoutBaseProps {
  icon?: ReactNode;
  primaryText?: ReactNode;
  secondaryText?: ReactNode;
  actions?: ReactNode;
}

const Root = styled.div`
  ${layoutTypographyMixin('xs')};
  display: flex;
  align-items: center;
  padding: ${iconTwoLineSizeVariant((branch) => branch.paddingTopAndBottom)} ${globalTheme.spacing.sm};
`;

const IconWrapper = styled.div<{ isSelected: boolean }>`
  ${Icon} {
    width: ${globalTheme.spacing.md};
    height: ${globalTheme.spacing.md};
    margin-right: ${globalTheme.spacing.sm};
    flex-shrink: 0;
    ${({ isSelected }) =>
      !isSelected &&
      css`
        color: ${globalTheme.palette.contrastLow};
      `}
  }
`;

const PrimaryTextWrapper = styled.div<Required<LayoutBaseProps>>`
  ${iconTwoLineSizeVariant((branch) => layoutTypographyMixin(branch.primaryLine.typographySize as SuppportedLayoutTypographySize))};
  margin-bottom: ${iconTwoLineSizeVariant((branch) => branch.primaryLine.marginBottom)};
`;

const SecondaryTextWrapper = styled.div<Required<LayoutBaseProps>>`
  ${iconTwoLineSizeVariant((branch) => layoutTypographyMixin(branch.secondaryLine.typographySize as SuppportedLayoutTypographySize))};
`;

const VBox = styled.div``;

export const IconTwoLinePure: FC<IconTwoLineLayoutProps> = ({
  actions,
  selectionVariant = 'solid',
  isSelected = false,
  showCheckIconWhenSelected = false,
  primaryText,
  secondaryText,
  icon,
  size = 'sm',
}) => (
  <Root size={size} isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
    <IconWrapper isSelected={isSelected}>{icon}</IconWrapper>
    <VBox>
      <PrimaryTextWrapper size={size} isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
        {primaryText}
      </PrimaryTextWrapper>
      <SecondaryTextWrapper size={size} isSelected={isSelected} selectionVariant={selectionVariant} showCheckIconWhenSelected={showCheckIconWhenSelected}>
        {secondaryText}
      </SecondaryTextWrapper>
    </VBox>
    {actions && <ActionsWrapper>{actions}</ActionsWrapper>}
    {isSelected && showCheckIconWhenSelected && <SelectedIcon />}
  </Root>
);

export const IconTwoLine = withItemContext(IconTwoLinePure);
